import Axios from "axios";
import {
  SET_LC_EXPORT_COMMERCIAL_INVOICE_LIST,
  UNSET_LC_EXPORT_COMMERCIAL_INVOICE_LIST,
} from "@/store/mutation-types";
import {
  saveUpdateLcExportLcCommercialInvoice,
  getExportLcCommercialInvoiceList,
  getExportLcCommercialInvoice
} from "@/store/api";

const state = {
  getExportLcCommercialInvoiceList: [],
};

const getters = {
  getExportLcCommercialInvoiceList(state) {
    return state.getExportLcCommercialInvoiceList;
  },
};

const mutations = {
  [SET_LC_EXPORT_COMMERCIAL_INVOICE_LIST](state, data) {
    state.getExportLcCommercialInvoiceList = data;
  },
  [UNSET_LC_EXPORT_COMMERCIAL_INVOICE_LIST](state) {
    state.getExportLcCommercialInvoiceList = [];
  },
};

const actions = {
  saveUpdateLcExportCommercialInvoice({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcExportLcCommercialInvoice, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getExportLcCommercialInvoiceList({ commit }) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(getExportLcCommercialInvoiceList)
        .then(function (response) {
          commit(SET_LC_EXPORT_COMMERCIAL_INVOICE_LIST, response.data.data || []);
          resolve(response);
        })
        .catch(function (error) {
          commit(UNSET_LC_EXPORT_COMMERCIAL_INVOICE_LIST);
          reject(error);
        }).then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getExportLcCommercialInvoiceById({ commit }, id) {
    const url = `${getExportLcCommercialInvoice}/${id}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(url)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

